import ClimateMap from './climateMap';

export default ClimateMap;
